/**
 * Multi-source TSA/Security Wait Time Types
 * Non-breaking: extends existing shapes with optional metadata fields only.
 */

export type WaitTimeSource = 'tsa_gov' | 'airport_official' | 'tsa_api' | 'estimate';

export interface WaitTimeResult {
  /** IATA airport code */
  airportCode: string;
  /** Wait time in minutes; null if unavailable */
  waitTimeMinutes: number | null;
  /** ISO 8601 timestamp of last data update */
  lastUpdatedISO: string;

  // ---- Optional enrichment fields (non-breaking) ----
  /** Which provider returned the data */
  source?: WaitTimeSource;
  /** 0–1 confidence score */
  confidence?: number;
  /** Named checkpoint if available */
  checkpointName?: string;
  /** User-facing disclaimer (e.g. "Estimated based on typical patterns") */
  disclaimer?: string;
  /** Raw provider payload for debugging */
  raw?: unknown;
}

export interface ProviderResponse {
  waitTimeMinutes: number | null;
  lastUpdatedISO: string;
  source: WaitTimeSource;
  confidence: number;
  checkpointName?: string;
  disclaimer?: string;
  raw?: unknown;
}

export interface WaitTimeProvider {
  name: WaitTimeSource;
  /** Returns null if this provider can't serve this airport */
  fetch(airportCode: string): Promise<ProviderResponse | null>;
}

/** Feature flags – read from import.meta.env with fallbacks */
export const FLAGS = {
  get USE_PROXY(): boolean {
    try {
      return import.meta.env.VITE_WAITTIME_USE_PROXY === 'true';
    } catch {
      return true; // default to proxy in Lovable Cloud
    }
  },
  get DEBUG(): boolean {
    try {
      return import.meta.env.VITE_WAITTIME_DEBUG === 'true';
    } catch {
      return false;
    }
  },
};
